<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Administradores</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn fab small color="primary lighten-4" @click="tooglePesquisa">
            <v-icon>search</v-icon>
          </v-btn>
          <v-btn
            depressed
            color="primary lighten-4"
            @click="$router.push('administradores/adicionar')"
            class="hidden-xs-only ml-2"
            >Adicionar</v-btn
          >
          <v-btn
            fab
            small
            color="primary lighten-4"
            @click="$router.push('administradores/adicionar')"
            class="hidden-sm-and-up ml-2"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-app-bar>
        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" class="pa-2">
            <v-col cols="12" pa-2>
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                dark
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                background-color="primary lighten-2"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-divider></v-divider>

        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="administradores"
          :loading="loading"
          hide-default-footer
        >
          <template v-slot:item.opcoes="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  @click="
                    $router.push('administradores/' + item.id + '/editar')
                  "
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">edit</v-icon>Editar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirModalExcluir(item)">
                  <v-list-item-title>
                    <v-icon class="mr-4">delete</v-icon>Excluir
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <as-dialogo
      ref="dialogoExcluir"
      title="Excluir"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Tem certeza que deseja excluir este administrador?</v-label>
      <div
        class="mt-4"
        style="display: flex; text-align: right; justify-content: flex-end;"
      >
        <v-btn depressed class="mr-4" @click="$refs.dialogoExcluir.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          @click="excluir"
          :disabled="salvando"
          :loading="salvando"
          >Excluir</v-btn
        >
      </div>
    </as-dialogo>
  </div>
</template>

<script>
import config from "@/config";
import Services from "@/services/services.js";
import ServiceAdministradores from "@/services/administradores.js";
import { ptDateFormat } from "@/util/dateFormat.js";

export default {
  name: "Administradores",
  data() {
    return {
      loading: false,
      salvando: false,
      validateForm: false,
      pesquisa: "",
      exibirPesquisa: false,
      storage: JSON.parse(localStorage.getItem("user")),
      tipo: JSON.parse(localStorage.getItem("user")).tipo,
      administrador: {},
      headers: [
        { text: "Nome", value: "nome", width: "30%" },
        { text: "Email", value: "email", width: "25%" },
        {
          text: "Telefone",
          value: "telefone",
          width: "20%",
          class: "hidden-xs-only",
        },
        {
          text: "Celular",
          value: "endereco.celular",
          width: "20%",
          class: "hidden-xs-only",
        },
        { text: "", value: "opcoes", width: "5%", sortable: false },
      ],
      administradores: [],
      modalFormAdministrador: false,
      modalExcluir: false,
      ptDateFormat,
    };
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 100);
      }
    },
    async listar() {
      try {
        this.loading = true;
        let administradores = await ServiceAdministradores.listar();
        this.administradores = administradores.data.administradores;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar administradores");
      } finally {
        this.loading = false;
      }
    },
    fecharModalFormAdministrador() {
      this.modalFormAdministrador = false;
      this.limpar();
    },
    diasAnteriores(date) {
      let hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      return date < hoje;
    },
    abrir() {
      this.loading = true;
      setTimeout(() => {
        this.$refs.nome.focus();
      }, 100);
      this.modalFormAdministrador = true;
    },
    abrirModalExcluir(administrador) {
      this.administrador = this.clone(administrador);
      this.$refs.dialogoExcluir.abrir();
    },
    excluir() {
      this.salvando = true;
      this.$refs.dialogoExcluir.fechar();
      return ServiceAdministradores.excluir(this.administrador.id)
        .then((response) => {
          let administradorIndice = this.administradores.findIndex(
            (administrador) => administrador.id == this.administrador.id
          );
          this.administradores.splice(administradorIndice, 1);
          this.salvando = false;
        })
        .catch((error) => {
          this.salvando = false;
          if (error.response.status == 401) {
            this.$root.$children[0].makeLogOff = true;
          }
        });
    },
  },
  mounted() {
    this.listar();
  },
};
</script>

<style></style>
